import React from 'react'
import { SvgIcon } from '@material-ui/core'

export default function NmkIcon() {
  return (
    <SvgIcon>
      <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        preserveAspectRatio="xMidYMid meet"
      >
<g>
	<path class="st0" d="M11.37,16.23c-1.17-1.16-2.34-2.34-3.49-3.49c-1.15,1.15-2.32,2.32-3.48,3.48c1.16,1.16,2.33,2.33,3.49,3.49
		C9.04,18.55,10.21,17.38,11.37,16.23z M12.99,7.65c1.17,1.17,2.35,2.34,3.5,3.49c1.15-1.15,2.32-2.32,3.48-3.47
		c-1.16-1.16-2.33-2.33-3.5-3.5C15.32,5.33,14.15,6.5,12.99,7.65z M19.97,16.34c-1.16-1.16-2.33-2.33-3.49-3.49
		c-1.16,1.16-2.34,2.33-3.5,3.49c1.16,1.15,2.33,2.32,3.49,3.49C17.64,18.68,18.81,17.51,19.97,16.34z M7.89,4.18
		C6.72,5.34,5.55,6.51,4.36,7.71c0.03,0.01,0.07,0.04,0.11,0.06c1.1,1.1,2.2,2.2,3.3,3.3c0.11,0.11,0.11,0.11,0.23-0.01
		c1.1-1.1,2.21-2.21,3.31-3.31c0.03-0.03,0.06-0.06,0.08-0.09C10.21,6.51,9.04,5.34,7.89,4.18z M8.69,3.73
		c1.17,1.17,2.34,2.34,3.49,3.49c1.16-1.16,2.33-2.32,3.49-3.49C13.36,3.73,11.03,3.73,8.69,3.73z M7.5,11.92
		c-1.16-1.16-2.33-2.33-3.49-3.49c0,2.31,0,4.65,0,6.96C5.18,14.24,6.35,13.08,7.5,11.92z M12.18,15.44
		c1.16-1.16,2.33-2.33,3.49-3.49c-2.32,0-4.65,0-6.98,0C9.86,13.12,11.03,14.28,12.18,15.44z M8.68,20.29c2.34,0,4.68,0,6.99,0
		c-1.16-1.16-2.33-2.33-3.49-3.49C11.03,17.95,9.86,19.11,8.68,20.29z"/>
	<path d="M11.37,16.23c-1.15,1.15-2.32,2.32-3.48,3.47c-1.15-1.15-2.33-2.32-3.49-3.49c1.15-1.15,2.32-2.32,3.48-3.48
		C9.03,13.89,10.2,15.06,11.37,16.23z"/>
	<path d="M12.99,7.65c1.15-1.15,2.32-2.32,3.48-3.47c1.16,1.16,2.33,2.33,3.5,3.5c-1.15,1.15-2.32,2.32-3.48,3.47
		C15.33,9.99,14.16,8.82,12.99,7.65z"/>
	<path d="M19.97,16.34c-1.17,1.17-2.33,2.33-3.49,3.49c-1.16-1.15-2.33-2.32-3.49-3.49c1.16-1.16,2.33-2.33,3.5-3.49
		C17.65,14.02,18.81,15.18,19.97,16.34z"/>
	<path d="M7.89,4.18c1.15,1.15,2.32,2.32,3.5,3.49c-0.02,0.02-0.05,0.06-0.08,0.09C10.21,8.87,9.1,9.97,8,11.08
		c-0.12,0.12-0.12,0.12-0.23,0.01c-1.11-1.1-2.21-2.21-3.31-3.31c-0.03-0.03-0.07-0.05-0.1-0.06C5.55,6.51,6.72,5.34,7.89,4.18z"/>
	<path d="M8.69,3.73c2.33,0,4.66,0,6.99,0c-1.17,1.17-2.34,2.33-3.49,3.49C11.03,6.06,9.86,4.9,8.69,3.73z"/>
	<path d="M7.5,11.92c-1.15,1.15-2.32,2.32-3.49,3.48c0-2.32,0-4.66,0-6.96C5.17,9.59,6.33,10.76,7.5,11.92z"/>
	<path d="M12.18,15.44c-1.15-1.15-2.32-2.32-3.49-3.49c2.33,0,4.66,0,6.98,0C14.51,13.11,13.34,14.27,12.18,15.44z"/>
	<path d="M8.68,20.29c1.18-1.18,2.35-2.34,3.5-3.49c1.16,1.16,2.33,2.33,3.49,3.49C13.36,20.29,11.03,20.29,8.68,20.29z"/>
</g>    </svg>
    </SvgIcon>
  )
}
